import React from 'react';
import { Box, Typography, Chip, LinearProgress } from '@mui/material';

const PasswordStrengthIndicator = ({ password, strength }) => {
  const getPasswordStrengthLabel = () => {
    switch (strength) {
      case 0:
      case 1:
        return { label: "Very Weak", color: "#dc3545" };
      case 2:
        return { label: "Weak", color: "#fd7e14" };
      case 3:
        return { label: "Fair", color: "#ffc107" };
      case 4:
        return { label: "Good", color: "#20c997" };
      case 5:
        return { label: "Strong", color: "#28a745" };
      default:
        return { label: "Very Weak", color: "#dc3545" };
    }
  };

  const strengthInfo = getPasswordStrengthLabel();

  return (
    <Box sx={{ mt: 1 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1,
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Password Strength:
        </Typography>
        <Chip
          label={strengthInfo.label}
          size="small"
          sx={{
            backgroundColor: strengthInfo.color,
            color: "white",
            fontWeight: 500,
            fontSize: "0.7rem",
          }}
        />
      </Box>
      <LinearProgress
        variant="determinate"
        value={(strength / 5) * 100}
        sx={{
          height: 6,
          borderRadius: 3,
          backgroundColor: "#e0e0e0",
          "& .MuiLinearProgress-bar": {
            backgroundColor: strengthInfo.color,
            borderRadius: 3,
          },
        }}
      />
      <Box sx={{ mt: 1 }}>
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ fontSize: "0.7rem" }}
        >
          Requirements: 8+ characters, uppercase, lowercase, number, special
          character
        </Typography>
      </Box>
    </Box>
  );
};

export default PasswordStrengthIndicator;
